var cjs = {exports: {}};

export { cjs as __module };
//# sourceMappingURL=index3.js.map
